import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { Tutorial, TutorialPermission } from "../models/tutorial.model";

@Injectable()
export class TutorialService extends BaseService<Tutorial> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public list(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + '/list',  { headers: this.headers });
  }
  public updateList(data: any): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/items', data, { headers: this.headers });
  }

  public deleteList(ids: number[]): Observable<any> {
    return this.http.delete<any>(this.baseUrl + '/items', { body: { ids: ids } });
  }

  public getPermission(): Observable<TutorialPermission> {
    return this.http.get<TutorialPermission>(this.baseUrl + '/permission', { headers: this.headers });
  }

  public getPathModule(): string {
    return '/tutorial';
  }
}